import { resolve } from "inversify-react";
import { injectable } from "inversify";
import React, {ReactElement} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {store} from "../../app/store/store";
import {setCaptcha} from "../Auth/slice";
import {verifyCaptcha} from "../Auth/api";
import {LocalStorageEnum} from "../../enum/localStorage";

export interface ICaptcha<T> {
    token: string
    render(): T;
}

const captchaHandler = (value: string | null) => {
    if (value) {
        verifyCaptcha(value).then(() => {
            localStorage.setItem(LocalStorageEnum.captcha, value)
            store.dispatch(setCaptcha(value))
        }).catch(() => {
            localStorage.removeItem(LocalStorageEnum.captcha)
            store.dispatch(setCaptcha(null))
        })
    } else {
        localStorage.removeItem(LocalStorageEnum.captcha)
        store.dispatch(setCaptcha(null))
    }
}

@injectable()
export class CaptchaProvider implements ICaptcha<ReactElement> {

    token = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'

    render() {
        return <ReCAPTCHA
            style={{marginTop: '16px'}}
            sitekey={this.token}
            onExpired={() => captchaHandler(null)}
            onChange={value => captchaHandler(value)}/>;
    }
}

export class Captcha extends React.Component {

    @resolve('captchaProvider') private readonly captchaProvider!: ICaptcha<ReactElement>

    render() {
        return this.captchaProvider.render()
    }
}

